<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green">
                    <v-flex slot="header">
                        <v-layout row>
                            <span
                                class="subheading font-weight-light mr-3"
                                style="align-self: center"
                                >{{ title }}</span
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                class="mr-2 my-0"
                                style="background-color: #fff; color: #4caf50 !important"
                                @click="openNewMessageDialog()"
                            >
                                New Message
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-data-table
                        v-if="!isMobile"
                        :headers="headers"
                        :items="messages"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewMessage(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getStatusIconColor(
                                                        item.Status,
                                                    )
                                                "
                                                >{{
                                                    getStatusIcon(item.Status)
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.Status }}</span>
                                    </v-tooltip>
                                </td>
                                <td
                                    style="min-width: 210px"
                                    class="text-xs-left font-weight-regular"
                                >
                                    {{ item.Date }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.SenderName }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.SenderPhone }}
                                </td>
                                <td>
                                    <audio
                                        controls
                                        :src="item.RecordingURL"
                                    ></audio>
                                </td>
                                <td>
                                    <audio
                                        controls
                                        :src="item.OriginalRecordingURL"
                                    ></audio>
                                </td>
                                <td
                                    class="text-xs-left font-weight-regular"
                                    style="min-width: 300px"
                                >
                                    {{ item.PhoneNumberList }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2" v-if="!isMobile">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                    <div v-if="isMobile">
                        <div v-for="(message, index) in getLastMessages()">
                            <div>
                                <v-icon
                                    class="mr-2 "
                                    dark
                                    :color="getStatusIconColor(message.Status)"
                                    >{{ getStatusIcon(message.Status) }}</v-icon
                                >{{ message.Status }}
                            </div>
                            <div class="my-1">{{ message.Date }}</div>
                            <div>
                                {{
                                    message.SenderName +
                                        "        " +
                                        message.SenderPhone
                                }}
                            </div>
                            <audio
                                controls
                                class="mt-2"
                                style="width: 100%;"
                                :src="message.RecordingURL"
                            ></audio>
                            <v-divider
                                class="mb-2 mt-1"
                                v-if="index + 1 < getLastMessages().length"
                                :key="index"
                            ></v-divider>
                        </div>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="newMessageDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">New Message</div>

                <v-btn
                    small
                    class="mr-2 mt-4"
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".mp3"
                    @change="onFilePicked($event)"
                />
                <div v-if="files.length" class="mt-0 ml-2 mb-2">
                    {{ files[0].name }}
                </div>
                <audio
                    class="mt-2 mb-3"
                    v-if="newMessage.recordingURL"
                    controls
                    ref="recordingURL"
                    :src="newMessage.recordingURL"
                ></audio>
                <v-text-field
                    class="mt-2 mb-3"
                    v-model="newMessage.phone"
                    hide-details
                    label="From Phone"
                ></v-text-field>
                <v-textarea
                    class="mt-2 mb-3"
                    v-model="newMessage.subject"
                    rows="2"
                    outline
                    hide-details
                    label="Subject"
                ></v-textarea>
                <v-btn
                    class="mt-0 mb-3 py-0"
                    small
                    :disabled="!newMessage.subject"
                    @click="playText(newMessage.subject)"
                    color="info"
                >
                    Play
                </v-btn>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="newMessageDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="sending"
                        @click="sendNewMessage"
                        >Send Message</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewMessageDialog" max-width="900">
            <v-card class="pa-4">
                <div
                    class="my-3 mx-1 pa-2"
                    style="border: 2px solid #43a047; width: 50%;"
                >
                    <div v-for="(info, index) in clickedMessage.listeners">
                        <v-layout row>
                            <div
                                style="width: 200px"
                                class="font-weight-medium"
                            >
                                {{ info.Name }}
                            </div>
                            <div>{{ info.Time }}</div> </v-layout
                        ><v-divider
                            class="mb-2 mt-1"
                            v-if="index + 1 < clickedMessage.listeners.length"
                        ></v-divider>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                </div>
                <pre>{{ viewMessageText | pretty }}</pre>
                <v-card-actions>
                    <v-btn @click="viewMessageDialog = false" color="#999" dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data() {
        return {
            title: "Credit",
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            isMobile: false,

            headers: [
                { value: "Status", text: "Status" },
                { value: "Timestamp", text: "Timestamp" },
                { value: "SenderName", text: "Sender" },
                { value: "SenderPhone", text: "Sender Phone" },
                { value: "RecordingURL", text: "Recording" },
                { value: "OriginalRecordingURL", text: "Original" },
                { value: "phoneNumberList", text: "Sent To" },
            ],

            messages: [],

            viewMessageDialog: false,
            viewMessageText: "",
            clickedMessage: "",

            newMessageDialog: false,
            uploading: false,
            sending: false,
            files: [],

            newMessage: {
                recordingURL: "",
                subject: "",
                phone: "13479710707",
            },

            awsPolly: "",
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    mounted() {
        this.awsPolly = new AWS.Polly({
            accessKeyId: "AKIA3LKZMVJXVMXC6IK6",
            secretAccessKey: "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",
            region: "us-east-1",
        });
    },
    created() {
        this.firebaseSetup();
        //this.loadAccount();
        //this.loadData();
        this.isMobile = window.innerWidth < 551;
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("messages");

            const messagesRef = ref.orderByKey().limitToLast(300);

            messagesRef.on(
                "value",
                (snapshot) => {
                    console.log(snapshot.val());
                    const messages = Object.values(snapshot.val()).map(
                        (message) => {
                            message.SenderPhone = this.formatPhoneNumber(
                                message.SenderPhone,
                            );

                            message.PhoneNumberList = message.PhoneNumbers.map(
                                (m) => this.formatPhoneNumber(m.Phone),
                            ).join(",");

                            message.Date = moment(message.Timestamp).format(
                                "LLL",
                            );

                            return message;
                        },
                    );
                    this.messages = messages.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = this.messages.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            ref.on("child_added", (data, prevChildKey) => {
                // const message = data.val();
                // message.SenderPhone = this.formatPhoneNumber(
                //     message.SenderPhone
                // );
                // message.PhoneNumberList = message.PhoneNumbers.map(m =>
                //     this.formatPhoneNumber(m.Phone)
                // ).join(",");
                // message.Timestamp = moment(message.Timestamp).format("LLL");
                // this.messages.push(message);
            });

            // ref.on("child_changed", function(data, prevChildKey) {
            //     console.log(data.val());
            // });

            var accountRef = firebase.database().ref("account");

            const accounts = accountRef.orderByKey().limitToLast(1);

            accounts.on(
                "value",
                (snapshot) => {
                    const accountInfo = Object.values(snapshot.val()).map(
                        (account) => {
                            this.title =
                                "Plivo: $" +
                                account.Credit.toFixed(2) +
                                " | " +
                                "Twilio : $" +
                                account.TwilioCredit.toFixed(2);

                            return account;
                        },
                    );
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        getLastMessages() {
            return this.messages.slice(0, 30);
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        async loadData() {
            const messages = await ky("api/home/getMessages", {
                prefixUrl: this.getDomain(),
            }).json();

            this.pagination.totalItems = messages.length;
            this.messages = messages;
        },
        async loadAccount() {
            const account = await ky("api/home/getAccount", {
                prefixUrl: this.getDomain(),
            }).json();

            const credit = +JSON.parse(account).cash_credits;

            this.title = "Credit: $" + credit.toFixed(2);
        },
        getDomain() {
            return window.location.host.includes("localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "InProgress":
                case "Queued":
                    return "mdi-progress-upload";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "InProgress":
                case "Queued":
                    return "#42A5F5";
                case "Pending":
                    return "#fdb400";
            }
        },
        async viewMessage(message) {
            const url =
                "http://broadcastvoicemailwer.azurewebsites.net/api/broadcast/GetListenersSql?recordingURL=" +
                message.RecordingURL;

            const response = await this.$http.get(url);

            message.listeners = response.data.listeners;

            this.clickedMessage = message;

            this.viewMessageText = message;
            this.viewMessageDialog = true;

            console.log(JSON.stringify(message, null, 2));
        },
        openNewMessageDialog() {
            this.newMessageDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            var formData = new FormData();

            formData.append("file", files[0]);

            try {
                const response = await this.$http.post(
                    this.getDomain() + "/api/home/GetUrl?type=greeting",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.newMessage.recordingURL = response.data;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async sendNewMessage() {
            if (!this.$refs.recordingURL || !this.$refs.recordingURL.duration)
                return;

            this.sending = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/broadcast/sendMessageAsQueued",
                    {
                        recordingURL: this.newMessage.recordingURL,
                        subject: this.newMessage.subject,
                        phone: this.newMessage.phone,
                        recordingDuration: this.$refs.recordingURL.duration,
                    },
                );

                this.sending = false;
                this.newMessageDialog = false;

                this.newMessage.recordingURL = "";
                this.newMessage.subject = "";
            } catch (e) {
                this.sending = false;
            }
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
</style>
